<template>
<div class="banner form dialog-form">
    <el-dialog title="选择微页面" :visible.sync="dialogVisible" :show-close='false'>
        <div class="filters">
            <div class="search">
                <el-input placeholder="输入微页面名称" v-model="param.pagename" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
            <div class="add"></div>
        </div>
        <el-table :data="tableData" style="width: 100%" @select="selected" ref="multipleTable" max-height="300">
            <el-table-column type="selection" width="30"></el-table-column>
            <el-table-column label="页面名称" min-width="200px">
                <template slot-scope="scope">
                    <div class="imageText">
                        <!-- <img :src="scope.row.logoPic.furl" alt="" v-if="scope.row.logoPic.furl"> -->
                        <!-- <img :src="defaultCover" alt="" v-else> -->
                        <div class="imageText-summary">
                            <div class="pageName">
                                <span>{{ scope.row.pagename }}</span>
                                <span v-if="scope.row.isdefault === 1" class="pageHome">店铺主页</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="datetime"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
    </span>
    </el-dialog>
</div>
</template>

<script>
import {getMicroPageList} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'banner',
    data() {
        return {
            param: {
                pagename: ''
            },
            page: {
                page: 0,
                pageSize: 10
            },
            dialogVisible: false,
            tableData: [],
            selectedResult: {
                innerid: '',
                name: ''
            },
            flag: true,
            scrollTop: 0, // 上一次滚动距离
            selectPage: null
        }
    },
    mounted() {
        this._getList()
    },
    updated() {
    },
    methods: {
        handleQuery() {
            this.page.page = 0
            this.tableData = []
            this.flag = true
            this._getList()
        },
        selected(selection, row) {
            this.$refs.multipleTable.clearSelection()
            this.$refs.multipleTable.toggleRowSelection(row)
            this.selectPage = row
        },
        openDialog(selectedResult) {
            this.tableData = []
            this.param.subject = ''
            this.selectedResult = $.extend(true, [], selectedResult)
            this.dialogVisible = true
            this._getList()
        },
        cancel() {
            this.param.pagename = ''
            this.page = {
                page: 0,
                pageSize: 6,
                pageCount: 0
            }
            this.flag = true
            this.dialogVisible = false
            this.selectPage = null
            this.setLoading(false)
            this.$emit('cancel')
        },
        submit() {
            this.$emit('setShop', this.selectPage)
            this.param.pagename = ''
            this.page = {
                page: 0,
                pageSize: 6,
                pageCount: 0
            }
            this.dialogVisible = false
        },
        _getList() {
            this.page.page++
            this.setLoading(true)
            getMicroPageList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.setLoading(false)
                    this.page = {
                        page: 0,
                        pageSize: 6,
                        pageCount: 0
                    }
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.banner {
    .el-dialog{
        width: 650px;
    }
    .el-dialog .el-button{
        margin-bottom: 0;
        margin-left: 30px;
    }
    .el-date-editor .el-range-separator,.filters .el-input__icon{
        line-height: 26px;
    }
    .el-table th>.cell:nth-child(1)>label{
        display: none;
    }
    .filters{
        @include flexBox(flex-start);
        .search{
            .el-input{
                width: 240px !important;
            }
        }
    }
    .imageText{
        .imageText-summary{
            .pageName{
                .pageHome{
                    width:56px;
                    height:18px;
                    text-align: center;
                    background: #409EFF;
                    line-height: 18px;
                    display: inline-block;
                    color: #fff;
                    font-size: 12px;
                    margin-left: 10px;
                }
            }
        }
    }
}
</style>
